var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_vm._v(" [ "),_vm._l((_vm.data),function(d,index){return _c('span',{key:index,staticClass:"mx-2"},[_c('span',{class:{ 'pause-value': d.type === 'pause' }},[_vm._v(_vm._s(d.duration))]),(index + 1 < _vm.data.length)?_c('span',[_vm._v(", ")]):_vm._e()])}),_vm._v(" ] ")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }